declare var require: any;

export const environment = {
  production: true,
  API_ENDPOINT: '/telea_clinica_paciente_wss/wss_public/v1',
  VERSION: require('../assets/app-config.json').VERSION
};
